import { render, staticRenderFns } from "./CustomFieldForm.vue?vue&type=template&id=7945d0c7&scoped=true&"
import script from "./CustomFieldForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7945d0c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7945d0c7')) {
      api.createRecord('7945d0c7', component.options)
    } else {
      api.reload('7945d0c7', component.options)
    }
    module.hot.accept("./CustomFieldForm.vue?vue&type=template&id=7945d0c7&scoped=true&", function () {
      api.rerender('7945d0c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/CustomFieldForm.vue"
export default component.exports